var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStepped = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 5.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-3.25V8a.75.75 0 0 1-.75.75H6.75v1.75a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h3.25V8A.75.75 0 0 1 6 7.25h3.25V5.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStepped);
export default ForwardRef;